<template>
  <div class="wrapper">
    <header-comp></header-comp>
    <modals ref="modals"></modals>
    <transition name="slide" mode="out-in">
      <router-view :key="route.fullPath"></router-view>
    </transition>
    <footer-comp></footer-comp>
  </div>
</template>


<script>
import { mapState } from 'vuex';
import HeaderComp from "./Header/HeaderComp.vue"
import FooterComp from "./Footer/FooterComp.vue";

import { useRoute } from 'vue-router';
import Modals from "./Modal/Modals.vue";

export default {
  components:{
    Modals,
    FooterComp,
    HeaderComp
  },
  watch:{
    $route (to, from){
      setTimeout(() => {
        $([document.documentElement, document.body]).animate({
          scrollTop: $("header").offset().top - 30
        }, 0)},
          260
      )
    }
  },
  data(){
    return {
    }
  },
  computed:{
  },
  methods: {
    setLoading(){
      this.loading = true
    }
  },
  setup() {
    const route = useRoute();
    return { route };
  },
  mounted(){

  }
}
</script>
<style>

.slide-leave-active{
  transition: none;
}
.slide-enter-active {
  transition: transform 0.25s ease-out, opacity 0.25s ease-out;
  opacity:1;
}

.slide-enter-from {
  transform: translateX(7%);
  opacity:0;
}
.slide-leave-to {
}
</style>